export default __webpack_public_path__ + "static/media/Lupus.1975ef9c.jpg";